import React, { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot, getDocs } from 'firebase/firestore';
import { db, auth } from '../firebaseConfig';
import AppBar from './AppBar';
import EssayList from './EssayList';
import EssayEditor from './EssayEditor';
import SimilarNotes from './SimilarNotes';
import { calculateCosineSimilarity } from '../utils/embeddings';

function Essays() {
  const [essays, setEssays] = useState([]);
  const [selectedEssay, setSelectedEssay] = useState(null);
  
  // Fetch essays for current user
  useEffect(() => {
    const currentUser = auth.currentUser;
    if (!currentUser) return;

    const q = query(
      collection(db, "essays"),
      where("uid", "==", currentUser.uid)
    );
    
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const essaysData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setEssays(essaysData);
      
      // If we have a selected essay, update it with fresh data
      if (selectedEssay) {
        const updatedEssay = essaysData.find(essay => essay.id === selectedEssay.id);
        if (updatedEssay) {
          setSelectedEssay(updatedEssay);
        }
      }
    });

    return () => unsubscribe();
  }, []);

  const handleSelectEssay = (essay) => {
    setSelectedEssay(essay);
  };

  return (
    <div className="flex-col h-[100dvh] overflow-hidden">
      <div className="flex bg-gray-50 h-[100dvh]">
        {/* Essays list panel */}
        <EssayList 
          essays={essays}
          onSelectEssay={handleSelectEssay}
          selectedEssayId={selectedEssay?.id}
        />

        {/* Essay editor panel */}
        {selectedEssay && (
          <EssayEditor 
            essay={selectedEssay}
          />
        )}
      </div>
      <AppBar 
        className="fixed bottom-0 left-0 right-0"
        onSubmit={() => {}}
      />
    </div>
  );
}

export default Essays; 